import { render, staticRenderFns } from "./Games.vue?vue&type=template&id=7f60886a&"
import script from "./Games.vue?vue&type=script&lang=ts&"
export * from "./Games.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports